<template>
  <div class="swiper-container x-swiper" ref="swiper">
    <div class="swiper-wrapper">
      <slot>
        <div v-for="item in 5" :key="item" class="swiper-slide">Slide{{ item }}</div>
      </slot>
    </div>
    <!-- 如果需要分页器 -->
    <div v-if="isPage" class="swiper-pagination"></div>

    <!-- 如果需要导航按钮 -->
    <div class="navigation" v-if="nav">
      <!-- <div class="prev">←</div>
      <div class="next">→</div> -->
      <div class="img1">
        <img src="~_img/common/arrow-org.png" class="prev" />
      </div>
      <div class="img2">
        <img src="~_img/common/arrow-org.png" class="next" />
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'x-swiper',
  props: {
    isPage: {
      type: Boolean,
      default: true
    },
    num: {
      type: Number | String,
      default: 3
    },
    nav:{
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      swiper: null
    }
  },
  mounted() {
    this.swiper = new Swiper(this.$refs.swiper, {
      // direction: 'vertical', // 垂直切换选项
      // loop: true, // 循环模式选项
      slidesPerView: this.num,
      // autoplay: true,
      // 如果需要分页器
      // pagination: {
      //   el: '.swiper-pagination',
      //   clickable: true
      // },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: '.next',
        prevEl: '.prev'
      }
    })
  },
  methods: {
    update() {
      this.swiper.update()
    }
  }
}
</script>

<style lang="less" scoped>
.swiper-container {
  height: 300px;
  position: relative;
}
.swiper-slide {
  background: lightblue;
  width: 100%;
}
.navigation {
   .img1,.img2{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 999;
    cursor: pointer;
    background: #fff;
    width: 20px;
    height: 100%;
  }
  .img1 {
    left: 0;
  }
  .img2 {
    right: 0;
  }
  .prev,
  .next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    // z-index: 999;
    // cursor: pointer;
    // background: #fbfbfb;
    width: 20px;
  }
  .prev {
    left: 4px;
  }
  .next {
    right: 4px;
    transform: rotate(180deg);
    top:22px;
  }
 
}
// .navigation {
//   .prev,.next {
//     position: absolute;
//     top: 50%;
//     transform: translateY(-50%);
//     font-size: 30px;
//     background: lightblue;
//     z-index: 9;
//     padding: 30px 6px;
//     cursor: pointer;
//   }
//   .prev{
//     left: 0;
//   }
//   .next{
//     right: 0;
//   }
// }
</style>
